export function buildSubtitlePreviewConfig<T extends { fontFamily: string }>({
  subtitleData,
  resolvedFontFamily,
}: {
  subtitleData: T;
  resolvedFontFamily: string | null | undefined;
}): T {
  return {
    ...subtitleData,
    fontFamily: resolvedFontFamily || subtitleData.fontFamily,
  };
}
